import { PropsWithChildren } from "react";
import { classNames } from "../../util/helpers";
import TableFootBar from "./TableFootBar";
import TablePagination, { TablePageSizeSelector, TablePaginationInfo } from "./TablePagination";
import TableView from "./TableView";

const TableAdvanceView = ({ children, basic = false }: PropsWithChildren & { basic?: boolean }) => {

    return <div className={classNames(basic ? 'ted-ui-TableBasic' : 'ted-ui-TableWithControls')}>
        {/* <TableInlineMessage /> */}
        {children}
        <TablePaginationInfo />
        <TableView />
        <TableFootBar>
            <TablePagination />
            <TablePageSizeSelector id={'page-size-selector-bottom-control'} />
        </TableFootBar>
    </div>;
};

export default TableAdvanceView;